import { IMappingBook } from '@shared/services/docs.service';

import * as XLSX from 'xlsx';

export function formatMappingToXLSX(mappingBooks: IMappingBook[]): XLSX.WorkBook {
	const wb = XLSX.utils.book_new();
	const rows: Array<Array<string>> = [['tags', 'key', 'value']];

	for (const mapping of mappingBooks) {
		// tags are displayed is separated using "," and is therefore not supported in CSV
		const tags = mapping.tags.replace(/, /g, ';');

		// Extract keys from mappingDocument
		const mappings = Object.entries(mapping.mappingDocument['--systemspecificmappings--']);

		// Add mappings to row
		for (const mappingEntry of mappings) {
			const [key, value] = mappingEntry;

			// Skip empty keys
			if (key === '') {
				continue;
			}

			rows.push([tags, key, value]);
		}
	}

	const sheet = XLSX.utils.aoa_to_sheet(rows);

	sheet['!protect'] = {
		insertColumns: true,
	};

	XLSX.utils.book_append_sheet(wb, sheet, 'Mappings');

	return wb;
}
